<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-2" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-primary " >
                <template #default>سوالات شما   </template>
                </m-h3><m-h4 v-bind='{...{},...{}}' :style='""' class="text-secondary" >
                <template #default>پاسخ داده شده توسط وکلای دزفول   </template>
                </m-h4><m-posts-1 v-bind='{...{"cardLink":false,"slicer":null,"contentType":"page","paginate":true,"categoryPanel":false,"flatCategoriesShape":false,"contentCategories":["\u0633\u0648\u0627\u0644"],"postCard":"mPostCard311","postCardClass":"mb-2 col-lg-12 col-md-12","stores_filter":null},...{}}' :style='""' class="" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                </m-posts-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mPosts1 from '@moeinmdn/miw-alpha-components/src/package/Post/Posts/Posts1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH3,mH4,mPosts1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
